module.exports = __webpack_public_path__ + "img/outlook_sync_scheduled.a224fb46.png";